/* =======================================================================
   Ella & Marie – Größentabelle / Size Chart Popup
   --------------------------------------------------------------------------
   Bevat twee onafhankelijke verantwoordelijkheden:

   A) POPUP-BEHEER
      Sluit via X, klik buiten de modal en Escape. Scroll-lock + focus-herstel.
      Trigger-logica:
        1) Zichtbare bestaande size-chart link (Swatch King / app) hergebruiken.
        2) Anders: eigen fallback-link tonen en in .size-chart-right plaatsen.

   B) UNIT-SWITCH (CM / INCHES)
      Voegt een CM | INCHES toggle toe boven de tabel(len).
      - Standaard CM voor DE/AT; standaard INCHES voor EN (Canada market).
      - Standaard gelezen uit data-ella-sc-locale op de wrapper-div.
      - Gebruiker kan zelf wisselen.
      - Converteert alle celwaarden on-the-fly (1 in = 2.54 cm).
      - Verwerkt ALLE tabellen binnen dezelfde popup (bijv. Top + Rock).
      - Herkent: enkelvoudige getallen, ranges (90–94), plus-suffix (110+),
        komma-decimalen (97,5), lege-cellen (—), en niet-numerieke cellen.
      - Kolom-headers: taal volgt de locale (DE óf EN), NIET de unit.
   ======================================================================== */
(function () {
  if (window.__ellaSizeChartInit) return;
  window.__ellaSizeChartInit = true;

  /* ---------------------------------------------------------------------- */
  /* A) POPUP-BEHEER                                                         */
  /* ---------------------------------------------------------------------- */

  var MODAL_SEL    = '[data-ella-sc-modal]';
  var DIALOG_SEL   = '[data-ella-sc-dialog]';
  var OPEN_SEL     = '[data-ella-sc-open]';
  var CLOSE_SEL    = '[data-ella-sc-close]';
  var WRAP_SEL     = '[data-ella-size-chart]';
  var EXISTING_SEL = '.swatch-size-chart, .tool-tip-trigger[data-tool-tip="size-chart"]';
  var SLOT_SEL     = '.swatch-label-container.size-chart-right, .size-chart-right';
  /* BF Size Charts app-trigger (injecteert LAAT, ~15-20s na load). Wanneer onze
     eigen size-chart aanwezig is, moet deze BF-trigger verborgen/geneutraliseerd
     worden zodat er exact 1 "Größentabelle"-link overblijft (de onze). */
  var BF_SEL       = '.scr-open-size-chart';
  var ANIM_MS      = 220;

  var lastTrigger = null;

  function lockScroll(on) {
    var root = document.documentElement, body = document.body;
    if (on)  { root.classList.add('ella-sc-lock');    body.classList.add('ella-sc-lock'); }
    else     { root.classList.remove('ella-sc-lock'); body.classList.remove('ella-sc-lock'); }
  }

  function openModal(modal, trigger) {
    if (!modal || !modal.hidden) return;
    lastTrigger = trigger || null;
    modal.hidden = false;
    void modal.offsetWidth;
    modal.classList.add('is-open');
    lockScroll(true);

    /* Unit-switch initialiseren zodra popup voor het eerst geopend wordt */
    initUnitSwitch(modal);

    var closeBtn = modal.querySelector(CLOSE_SEL);
    if (closeBtn) { try { closeBtn.focus(); } catch (e) {} }
  }

  function closeModal(modal) {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    lockScroll(false);
    window.setTimeout(function () { modal.hidden = true; }, ANIM_MS);
    if (lastTrigger) { try { lastTrigger.focus(); } catch (e) {} lastTrigger = null; }
  }

  document.addEventListener('click', function (e) {
    var closeEl = e.target.closest && e.target.closest(CLOSE_SEL);
    if (closeEl) { e.preventDefault(); closeModal(closeEl.closest(MODAL_SEL)); return; }
    var overlay = e.target.closest && e.target.closest(MODAL_SEL);
    if (overlay && !e.target.closest(DIALOG_SEL)) { closeModal(overlay); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
      var open = document.querySelector(MODAL_SEL + '.is-open');
      if (open) closeModal(open);
    }
  });

  function isUsable(el) {
    if (!el) return false;
    if (!(el.offsetWidth > 0 || el.offsetHeight > 0)) return false;
    return el.textContent.replace(/\s+/g, '').length > 0;
  }

  function wireTrigger(el, modal) {
    if (!el || el.__ellaWired) return;
    el.__ellaWired = true;
    el.style.cursor = 'pointer';
    el.addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopImmediatePropagation();
      openModal(modal, el);
    }, true);
  }

  /* Verberg + neutraliseer de BF Size Charts-trigger(s). Onze eigen popup is de
     enige bron van waarheid wanneer custom.size_chart_table aanwezig is (= snippet
     gerenderd). BF injecteert laat, dus dit wordt herhaald via timers + observer. */
  function neutralizeBF() {
    document.querySelectorAll(BF_SEL).forEach(function (el) {
      if (el.__ellaBfKilled) return;
      el.__ellaBfKilled = true;
      el.setAttribute('aria-hidden', 'true');
      el.style.setProperty('display', 'none', 'important');
      el.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
      }, true);
    });
  }

  function wireTriggers() {
    var wrap = document.querySelector(WRAP_SEL);
    if (!wrap) { neutralizeBF(); return; }
    var modal    = wrap.querySelector(MODAL_SEL);
    var fallback = wrap.querySelector(OPEN_SEL) || document.querySelector(OPEN_SEL);
    if (!modal || !fallback) { neutralizeBF(); return; }

    /* Onze eigen trigger is altijd de enige zichtbare/bruikbare link. */
    wireTrigger(fallback, modal);
    var slot = document.querySelector(SLOT_SEL);
    if (slot && fallback.parentNode !== slot) {
      var placeholder = slot.querySelector('.swatch-size-chart');
      if (placeholder) placeholder.style.display = 'none';
      slot.appendChild(fallback);
    }
    fallback.hidden = false;

    /* BF-trigger (en evt. andere bestaande size-chart-app links) neutraliseren. */
    neutralizeBF();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireTriggers);
  } else {
    wireTriggers();
  }
  window.addEventListener('load', wireTriggers);
  window.setTimeout(wireTriggers, 800);
  window.setTimeout(wireTriggers, 2000);
  window.setTimeout(wireTriggers, 3500);

  /* MutationObserver: BF Size Charts injecteert zijn trigger pas na ~15-20s.
     Zodra een .scr-open-size-chart in de DOM verschijnt, opnieuw neutraliseren. */
  try {
    var bfObserver = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches(BF_SEL)) ||
              (n.querySelector && n.querySelector(BF_SEL))) {
            wireTriggers();
            return;
          }
        }
      }
    });
    bfObserver.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}


  /* ---------------------------------------------------------------------- */
  /* B) UNIT-SWITCH (CM / INCHES)                                            */
  /* ---------------------------------------------------------------------- */

  /* Kolomnamen DE → EN. Sleutel = DE-naam zonder “ (cm)” suffix. */
  var HEADER_MAP = {
    'Größe':          'Size',
    'Brustumfang':   'Bust',
    'Länge':          'Length',
    'Ärmellänge':     'Sleeve Length',
    'Taille':         'Waist',
    'Hüfte':          'Hip',
    'Schulter':       'Shoulder',
    'Schulterbreite': 'Shoulder Width',
    'Rocklänge':      'Skirt Length',
    'Gesamtlänge':    'Total Length'
  };

  /* En-dash (wordt gebruikt in bereiken: 90–94) */
  var EN_DASH = '–';

  /* Eenmalige cm-waarde (na verwijdering van spaties/komma-decimalen) omrekenen. */
  function cmToIn(str) {
    str = str.trim().replace(',', '.');
    /* Alleen PUUR numerieke waarden omrekenen. Beschermt o.a. maten als
       “2XL” (parseFloat zou daar 2 van maken → 0.8 inch). */
    if (!/^\d+(\.\d+)?$/.test(str)) return str;
    var n = parseFloat(str);
    if (isNaN(n)) return str;
    return (Math.round(n / 2.54 * 10) / 10).toFixed(1);
  }

  /*
   * Volledige celwaarde omrekenen naar inches.
   * Herkent: enkelvoudig getal, bereik (90–94), plus-suffix (110+),
   * lege cel of streepje (—/-), en niet-numerieke tekst (S/M/L/…).
   */
  function toInches(raw) {
    var str = (raw || '').trim();
    if (!str || str === '—' || str === '-') return str;  /* leeg of — */

    /* Bereik: “90–94” of “72–76” */
    if (str.indexOf(EN_DASH) !== -1) {
      return str.split(EN_DASH).map(cmToIn).join(EN_DASH);
    }

    /* Plus-suffix: “110+” */
    if (str.slice(-1) === '+') {
      return cmToIn(str.slice(0, -1)) + '+';
    }

    /* Enkelvoudig getal of onbekend formaat */
    return cmToIn(str);
  }

  /* Haalt de kaartnaam op zonder “ (cm)” suffix en zoekt de EN-vertaling op. */
  function toEnHeader(deText) {
    var key = deText.replace(/\s*\(cm\)\s*$/i, '').trim();
    return HEADER_MAP[key] || key;  /* fallback: DE zonder unit */
  }

  /* Stelt een unit in en werkt ALLE cellen in ALLE tabellen + actieve knop bij.
     Kolomkoppen worden NIET aangeraakt (taal is locale-vast). */
  function applyUnit(modal, unit) {
    /* LET OP: kolomkoppen worden hier NIET aangeraakt. De taal van de koppen
       hangt uitsluitend af van de locale (vast ingesteld in initUnitSwitch).
       De unit-switch rekent enkel de celwaarden om (cm <-> inches). */

    /* Alle cellen van ALLE tabellen binnen de popup (Top, Rock, …). Cellen
       zonder opgeslagen waarde overslaan (defensief). */
    modal.querySelectorAll('.ella-size-chart__table-wrap tbody td').forEach(function (td) {
      if (typeof td.dataset.ellaCmVal === 'undefined') return;
      td.textContent = (unit === 'in') ? td.dataset.ellaInVal : td.dataset.ellaCmVal;
    });

    /* Actieve knop markeren */
    var sw = modal.querySelector('[data-ella-sc-unit-switch]');
    if (sw) {
      sw.querySelectorAll('[data-ella-unit]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.ellaUnit === unit);
        btn.setAttribute('aria-pressed', btn.dataset.ellaUnit === unit ? 'true' : 'false');
      });
    }

    modal.dataset.ellaActiveUnit = unit;
  }

  /*
   * Initialiseert de unit-switch in de meegegeven modal.
   * Idempotent: doet niets als de switch al bestaat.
   * Verwerkt ALLE tabellen in de popup (niet enkel de eerste).
   */
  function initUnitSwitch(modal) {
    if (modal.querySelector('[data-ella-sc-unit-switch]')) return;

    var firstWrap = modal.querySelector('.ella-size-chart__table-wrap');
    if (!firstWrap) return;
    var tables = modal.querySelectorAll('.ella-size-chart__table-wrap table');
    if (!tables.length) return;

    /* Locale bepaalt de TAAL van de kolomkoppen (vast; onafhankelijk van de unit). */
    var wrapper    = modal.closest(WRAP_SEL) || document.querySelector(WRAP_SEL);
    var locale     = (wrapper && wrapper.dataset.ellaScLocale) || 'de';
    var defaultUnit = (locale === 'en') ? 'in' : 'cm';

    /* Elke tabel afzonderlijk verwerken: kop-taal vastzetten + cm/inch-waarden
       opslaan. De Größe/Size-kolom (S, M, L, XL, 2XL, 3XL) wordt per tabel
       gedetecteerd op kolomindex en NOOIT omgerekend. */
    tables.forEach(function (table) {
      var sizeCols = {};
      table.querySelectorAll('thead th').forEach(function (th, idx) {
        var raw = th.textContent.trim();
        var key = raw.replace(/\s*\(cm\)\s*$/i, '').trim();
        /* Vaste kop in de juiste taal; de unit-toggle wijzigt deze NOOIT. */
        th.textContent = (locale === 'en') ? (HEADER_MAP[key] || key) : key;
        if (key === 'Größe' || key === 'Size') sizeCols[idx] = true;
      });

      table.querySelectorAll('tbody tr').forEach(function (tr) {
        tr.querySelectorAll('td').forEach(function (td, idx) {
          var raw = td.textContent.trim();
          td.dataset.ellaCmVal = raw;
          td.dataset.ellaInVal = sizeCols[idx] ? raw : toInches(raw);
        });
      });
    });

    /* Toggle-element aanmaken */
    var sw = document.createElement('div');
    sw.setAttribute('data-ella-sc-unit-switch', '');
    sw.className  = 'ella-sc-unit-switch';
    sw.setAttribute('role', 'group');
    sw.setAttribute('aria-label', locale === 'en' ? 'Unit' : 'Einheid');
    sw.innerHTML =
      '<button type="button" class="ella-sc-unit-btn" data-ella-unit="cm"  aria-pressed="false">CM</button>' +
      '<button type="button" class="ella-sc-unit-btn" data-ella-unit="in"  aria-pressed="false">INCHES</button>';

    /* Klik-handler op de switch */
    sw.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ella-unit]');
      if (!btn) return;
      applyUnit(modal, btn.dataset.ellaUnit);
    });

    /* Switch invoegen vóór de eerste tabel-wrap (geldt voor alle tabellen). */
    firstWrap.parentNode.insertBefore(sw, firstWrap);

    /* Standaard eenheid instellen */
    applyUnit(modal, defaultUnit);
  }

})();
